(() => {
  const brewDose = 18;
  const amount = value => /500/.test(value) ? 500 : /2\s*kg/i.test(value) ? 2000 : /1\s*kg/i.test(value) ? 1000 : 0;
  const sizeLabel = size => size === 500 ? '500g (2 x 250g)' : size === 2000 ? '2kg (2 x 1kg)' : '1kg';
  const selectOffer = (config, mode, term, size, coffee, frequency) => {
    const product = config.products[mode === 'prepaid' ? term : 'recurring'];
    const variant = product?.variants.find(v => v.options[0] === (coffee === 'decaf' ? 'Decaf' : 'Everyday') && amount(v.options[1]) === size);
    const plan = product?.plans.find(p => mode === 'prepaid' || (frequency === 'fortnightly' ? /2 weeks/i : /monthly/i).test(p.name));
    const allocation = variant?.allocations.find(a => a.id === plan?.id);
    return allocation && variant?.available ? { variant, plan, ...allocation } : null;
  };
  const tierSaving = (config, state, size) => {
    const offer = selectOffer(config, state.mode, state.term, size, state.coffee, state.frequency);
    if (!offer) return null;
    let reference = 0, basis = '';
    if (state.mode === 'prepaid') {
      const monthly = selectOffer(config, 'recurring', 3, size, state.coffee, 'monthly');
      reference = monthly ? monthly.price * state.term : 0;
      basis = `vs ${state.term} monthly Tempo payments`;
    } else if (size !== 500 && config.retailKilo && ['regular', 'regional', 'manaca'].includes(state.coffee)) {
      reference = config.retailKilo * size / 1000;
      basis = 'vs Regional/Manaca one-time coffee';
    } else if (size === 2000) {
      const kilo = selectOffer(config, 'recurring', 3, 1000, state.coffee, state.frequency);
      reference = kilo ? kilo.price * 2 : 0;
      basis = 'vs two 1kg Tempo deliveries';
    }
    const saved = Math.max(0, reference - offer.price);
    return { saved, percent: saved ? Math.round(saved / reference * 100) : 0, basis };
  };
  window.TempoPricing = { tierSaving };
  async function init(root) {
    if (root.dataset.tempoReady) return;
    root.dataset.tempoReady = 'true';
    const one = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const config = JSON.parse(one('[data-tempo-config]').textContent);
    const coffees = config.coffees || [{key: 'regular', name: "Roaster's choice", image: config.photos.regular}, {key: 'decaf', name: 'Decaf', image: config.photos.decaf}];
    const coffeeChoice = key => coffees.find(coffee => coffee.key === key) || coffees[0];
    const coffeeLabel = key => coffeeChoice(key).name;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IE', { style: 'currency', currency: config.currency, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    const retailSaving = (size, price) => {
      if (!config.retailKilo || size === 500) return '';
      const retail = config.retailKilo * size / 1000;
      return retail > price ? `Save ${money(retail - price)} on coffee vs ${size === 2000 ? 'two' : 'a'} ${money(config.retailKilo)} ${size === 2000 ? 'bags' : 'bag'} of Regional or Manaca.` : '';
    };
    if (root.matches('[data-tempo-promo]')) {
      const state = { size: 1000, mode: 'recurring' };
      const draw = () => {
        const { size, mode } = state;
        const prepaid = mode === 'prepaid';
        const offer = selectOffer(config, mode, 3, size, 'regular', 'monthly');
        all('[data-tempo-promo-size]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.tempoPromoSize) === size)));
        all('[data-tempo-promo-mode]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tempoPromoMode === mode)));
        one('[data-tempo-promo-price]').textContent = offer ? money(offer.price) : 'Unavailable';
        one('[data-tempo-promo-unit]').textContent = prepaid ? '3 monthly deliveries' : 'per delivery';
        let saving = offer && !prepaid ? retailSaving(size, offer.price) : '';
        const ongoing = selectOffer(config, 'recurring', 3, size, 'regular', 'monthly');
        if (offer && prepaid && ongoing) {
          saving = `${money(offer.perDelivery)} per delivery.`;
          if (ongoing.price * 3 > offer.price) saving += ` Save ${money(ongoing.price * 3 - offer.price)} vs three ongoing deliveries.`;
        }
        one('[data-tempo-retail]').hidden = prepaid || !saving;
        one('[data-tempo-retail]').textContent = saving && !prepaid ? money(config.retailKilo * size / 1000) : '';
        one('[data-tempo-promo-saving]').textContent = saving || 'Republic of Ireland delivery included.';
        one('[data-tempo-start]').href = `${config.subscriptionUrl}?${prepaid ? 'mode=prepaid&term=3&' : ''}size=${size}`;
        const cta = one('[data-tempo-promo-cta]');
        if (cta) cta.textContent = offer ? prepaid ? 'Give a little Tempo' : 'Find my Tempo' : 'See available options';
        const assurance = one('[data-tempo-promo-assurance]');
        if (assurance) assurance.textContent = prepaid ? 'Pay once. Three deliveries. No auto-renewal.' : 'Monthly or fortnightly. Pause, skip or cancel anytime.';
        const prepayLink = one('[data-tempo-prepay]');
        if (prepayLink) prepayLink.href = `${config.subscriptionUrl}?mode=prepaid&size=${size}`;
      };
      all('[data-tempo-promo-size]').forEach(b => b.addEventListener('click', () => { state.size = Number(b.dataset.tempoPromoSize); draw(); }));
      all('[data-tempo-promo-mode]').forEach(b => b.addEventListener('click', () => { state.mode = b.dataset.tempoPromoMode; draw(); }));
      one('[data-tempo-promo-select]')?.addEventListener('change', event => { state.size = Number(event.target.value); draw(); });
      draw();
      return;
    }
    const form = one('[data-tempo-form]');
    const field = name => form.elements.namedItem(`tempo-${name}`);
    const params = new URLSearchParams(location.search);
    const editingKey = params.get('edit');
    const cartClient = window.TempoCart.makeClient(config);
    let editingItem = null;
    let editInvalid = false;
    let editLoading = Boolean(editingKey);
    const state = { mode: params.get('mode') === 'prepaid' ? 'prepaid' : root.dataset.defaultMode, term: Number(params.get('term') || root.dataset.defaultTerm), size: amount(params.get('size') || '') || 1000, coffee: params.get('track') === 'decaf' || params.get('coffee') === 'decaf' ? 'decaf' : 'regular', frequency: params.get('frequency') === 'fortnightly' ? 'fortnightly' : 'monthly', busy: false };
    if (!['recurring', 'prepaid'].includes(state.mode)) state.mode = 'recurring';
    const requestedCoffee = params.get('coffee');
    if (coffees.some(coffee => coffee.key === requestedCoffee) && [...field('coffee').options].some(option => option.value === requestedCoffee)) state.coffee = requestedCoffee;
    if (![3, 6].includes(state.term)) state.term = 3;
    const sixMonthAvailable = config.products['6']?.plans.length > 0;
    if (!sixMonthAvailable) {
      form.querySelector('[name="tempo-term"][value="6"]').closest('label').hidden = true;
      if (state.term === 6) state.term = 3;
    }
    if (params.get('size') === '1000') state.size = 1000;
    if (params.get('size') === '2000') state.size = 2000;
    // Preserve bookmarked variant choices without exposing the retired coffee tiers.
    const bookmarked = Object.values(config.products).filter(Boolean).flatMap(p => p.variants).find(v => String(v.id) === params.get('variant'));
    if (bookmarked) {
      state.size = amount(bookmarked.options[1]);
      if (bookmarked.options[0] === 'Decaf') state.coffee = 'decaf';
      else if (state.coffee === 'decaf') state.coffee = 'regular';
    }
    if ([...field('grind').options].some(o => o.value === params.get('grind'))) {
      field('grind').value = params.get('grind');
      field('grind').dispatchEvent(new Event('change', { bubbles: true }));
    }
    const frequencyLabel = () => state.frequency === 'monthly' ? 'Every month' : 'Every 2 weeks';
    const helper = () => {
      const cups = Number(field('cups').value);
      const guide = window.TempoGuide;
      const frequency = state.mode === 'prepaid' ? 'monthly' : state.frequency;
      const size = guide.recommend(cups, frequency);
      one('[data-tempo-coverage]').textContent = guide.coverage(state.size, cups, frequency);
      const alternativeFrequency = frequency === 'monthly' ? 'fortnightly' : 'monthly';
      const alternativeSize = guide.recommend(cups, alternativeFrequency);
      const alternativeDays = Math.round(guide.days(alternativeSize, cups) * 10) / 10;
      one('[data-tempo-recommendation]').textContent = `Suggested for this schedule: ${guide.label(size)}. ${state.mode === 'prepaid' ? 'Prepaid is monthly only. With an ongoing subscription, another option is' : 'Another option:'} ${guide.label(alternativeSize)} ${alternativeFrequency === 'monthly' ? 'monthly' : 'every 2 weeks'} (about ${alternativeDays} days of coffee).`;
      const apply = one('[data-tempo-apply]');
      apply.textContent = `Use ${guide.label(size)} ${frequency === 'monthly' ? 'monthly' : 'every 2 weeks'}`;
      apply.disabled = size === state.size || state.busy || editLoading || editInvalid;
      return { size, frequency };
    };
    const draw = () => {
      const prepaid = state.mode === 'prepaid';
      const gift = prepaid && field('gift').checked;
      all('[data-tempo-mode]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tempoMode === state.mode)));
      field('size').value = String(state.size); field('frequency').value = state.frequency; field('term').value = String(state.term); field('coffee').value = state.coffee;
      one('[data-tempo-frequency-wrap]').hidden = prepaid;
      one('[data-tempo-term-wrap]').hidden = !prepaid || !sixMonthAvailable;
      one('[data-tempo-gift-wrap]').hidden = !prepaid;
      one('[data-tempo-gift-fields]').hidden = !gift;
      field('recipient').disabled = !gift; field('recipient').required = gift; field('message').disabled = !gift;
      all('[data-tempo-size-price]').forEach(el => {
        const offer = selectOffer(config, state.mode, state.term, Number(el.dataset.tempoSizePrice), state.coffee, state.frequency);
        el.textContent = offer ? money(offer.price) : 'Unavailable';
        el.closest('label').querySelector('input').disabled = !offer;
      });
      all('[data-tempo-size-saving]').forEach(el => {
        const saving = tierSaving(config, state, Number(el.dataset.tempoSizeSaving));
        el.textContent = !saving ? '' : saving.saved ? `Save ${money(saving.saved)} \u00b7 ${saving.percent}%` : 'ROI delivery included';
      });
      const offer = selectOffer(config, state.mode, state.term, state.size, state.coffee, state.frequency);
      one('[data-tempo-size-note]').textContent = `About ${Math.round(state.size / brewDose)} cups at ${brewDose}g per brew. ${prepaid ? 'Prices cover all monthly deliveries.' : 'Prices are per delivery.'}`;
      one('[data-tempo-total]').textContent = offer ? money(offer.price) : 'Unavailable';
      one('[data-tempo-charge]').textContent = prepaid ? 'paid once' : 'per delivery';
      one('[data-tempo-summary]').textContent = `${sizeLabel(state.size)} - ${coffeeLabel(state.coffee)} - ${field('grind').value} - ${prepaid ? `Monthly for ${state.term} months` : frequencyLabel()}`;
      const comparison = tierSaving(config, state, state.size);
      let saving = comparison ? comparison.saved ? `Save ${money(comparison.saved)} (${comparison.percent}%) ${comparison.basis}.` : 'Republic of Ireland delivery included.' : '';
      if (offer && prepaid) saving = `${money(offer.perDelivery)} per delivery. ${saving}`;
      one('[data-tempo-saving]').hidden = !saving;
      one('[data-tempo-saving]').textContent = saving;
      one('[data-tempo-terms]').textContent = prepaid ? `${state.term} monthly deliveries. Ends automatically, no renewal.` : `Charged ${state.frequency === 'monthly' ? 'monthly' : 'every 2 weeks'}. Pause, skip or cancel anytime.`;
      one('[data-tempo-assurance]').textContent = gift ? "Republic of Ireland delivery included; Northern Ireland rates at checkout. Enter the recipient's delivery address at checkout." : 'Republic of Ireland delivery included. Northern Ireland rates at checkout. We deliver to these destinations only.';
      one('[data-tempo-control]').textContent = prepaid ? `${state.term} deliveries, no renewal` : 'Pause, skip or cancel';
      one('[data-tempo-submit]').disabled = !offer || state.busy || editLoading || editInvalid;
      one('[data-tempo-submit]').textContent = editLoading ? 'Loading your choices...' : state.busy ? editingKey ? 'Saving changes...' : 'Adding to bag...' : editingKey ? 'Save changes to bag' : 'Add Tempo to bag';
      form.setAttribute('aria-busy', String(state.busy || editLoading));
      form.inert = state.busy || editLoading;
      const coffee = coffeeChoice(state.coffee);
      const chosenForYou = state.coffee === 'regular';
      one('[data-tempo-coffee-heading]').textContent = chosenForYou ? 'A good coffee routine.' : coffee.name;
      one('[data-tempo-coffee-copy]').textContent = chosenForYou ? 'A rotation built around our favourite everyday coffees. Freshly roasted, ready for your favourite mug.' : coffee.notes || 'Your preferred core coffee, freshly roasted in Mullingar.';
      const coffeeEyebrow = one('[data-tempo-coffee-eyebrow]');
      if (coffeeEyebrow) coffeeEyebrow.textContent = chosenForYou ? 'Chosen at the roastery' : 'Your preferred coffee';
      const coffeeNote = one('[data-tempo-coffee-note]');
      if (coffeeNote) coffeeNote.textContent = chosenForYou ? 'Our roastery chooses the coffee for each delivery.' : `${coffee.name} is your preference for the full delivery. To change it later, email info@typo.ie.`;
      const taste = one('[data-tempo-taste]');
      taste.hidden = !chosenForYou && !coffee.notes;
      taste.textContent = chosenForYou ? 'A changing selection from our everyday core range, chosen at the roastery.' : `Tastes like: ${coffee.notes || ''}.`;
      const photo = one('[data-tempo-photo]');
      const placeholder = one('[data-tempo-photo-placeholder]');
      if (photo) {
        if (placeholder) photo.hidden = !coffee.image;
        if (coffee.image && photo.getAttribute('src') !== coffee.image) { photo.removeAttribute('srcset'); photo.src = coffee.image; }
        photo.alt = chosenForYou ? 'Typo Manaca coffee, an example of the roastery rotation' : `Typo ${coffee.name} coffee`;
      }
      if (placeholder) placeholder.hidden = Boolean(photo && coffee.image);
      one('[data-tempo-caption]').textContent = chosenForYou ? 'Shown: Manaca. Coffee changes with the rotation.' : coffee.image ? `Shown: ${coffee.name}. Your preferred coffee.` : `${coffee.name} preference selected.`;
      helper();
    };
    all('[data-tempo-mode]').forEach(b => b.addEventListener('click', () => { state.mode = b.dataset.tempoMode; draw(); }));
    form.addEventListener('change', e => {
      const name = e.target.name.replace('tempo-', '');
      if (['size', 'term'].includes(name)) state[name] = Number(e.target.value);
      if (['coffee', 'frequency'].includes(name)) state[name] = e.target.value;
      draw();
    });
    one('[data-tempo-apply]').addEventListener('click', () => { Object.assign(state, helper()); draw(); });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (state.busy || editLoading || editInvalid || !form.reportValidity()) return;
      const offer = selectOffer(config, state.mode, state.term, state.size, state.coffee, state.frequency);
      if (!offer) return;
      const properties = { 'Coffee choice': state.coffee === 'regular' ? "Roaster's choice" : coffeeLabel(state.coffee), 'Coffee selection': state.coffee === 'regular' ? "Roaster's rotation" : 'Preferred coffee', Grind: field('grind').value, Delivery: state.mode === 'prepaid' ? `${state.term} monthly deliveries, prepaid` : frequencyLabel(), _tempo: state.mode === 'prepaid' ? String(state.term) : 'recurring' };
      if (state.mode === 'prepaid' && field('gift').checked) {
        if (!field('recipient').value.trim()) { field('recipient').setCustomValidity("Enter the recipient's name."); field('recipient').reportValidity(); field('recipient').setCustomValidity(''); return; }
        properties.Gift = 'Yes'; properties.Recipient = field('recipient').value.trim();
        if (field('message').value.trim()) properties['Gift message'] = field('message').value.trim();
      }
      state.busy = true; one('[data-tempo-error]').hidden = true; draw();
      try {
        if (editingItem) {
          await cartClient.save(editingItem, {id: offer.variant.id, selling_plan: offer.id, properties});
          location.assign(config.cartUrl);
          return;
        }
        const response = await fetch(config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: offer.variant.id, quantity: 1, selling_plan: offer.id, properties }] }) });
        let data;
        try {
          // Shopify's Ajax API can return JSON with a text/javascript content type.
          data = await response.json();
        } catch {
          throw new Error('Shopify could not add this selection. Please refresh the page and try again.');
        }
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This selection could not be added. Please try again.');
        location.assign(config.cartUrl);
      } catch (error) {
        one('[data-tempo-error]').textContent = error.message || 'We could not reach the bag. Please try again.';
        one('[data-tempo-error]').hidden = false;
        state.busy = false; draw();
      }
    });
    draw();
    if (editingKey) {
      one('[data-tempo-edit-note]').hidden = false;
      try {
        if ((await cartClient.recover()).status === 'saved') { location.assign(config.cartUrl); return; }
        const cart = await cartClient.read();
        editingItem = cart.items.find(item => item.key === editingKey);
        if (!editingItem) throw new Error('This subscription is no longer in your bag. Return to your bag to review your current items.');
        const entry = Object.entries(config.products).find(([, product]) => product?.variants.some(variant => variant.id === editingItem.variant_id));
        const variant = entry?.[1].variants.find(variant => variant.id === editingItem.variant_id);
        const plan = entry?.[1].plans.find(plan => plan.id === editingItem.selling_plan_allocation?.selling_plan.id);
        if (!variant || !plan || !['Everyday', 'Decaf'].includes(variant.options[0])) throw new Error('This older selection cannot be edited here. Your bag is unchanged. Contact info@typo.ie for help.');
        const properties = editingItem.properties || {};
        const choice = properties['Coffee choice'];
        const coffee = !choice || choice === "Roaster's choice" || choice === 'Choose for me' ? 'regular' : coffees.find(coffee => coffee.name === choice)?.key;
        if (!coffee || ![...field('grind').options].some(option => option.value === properties.Grind)) throw new Error('We could not safely restore all of your choices. Your bag is unchanged. Return to your bag for help.');
        state.mode = entry[0] === 'recurring' ? 'recurring' : 'prepaid';
        state.term = state.mode === 'prepaid' ? Number(entry[0]) : 3;
        state.size = amount(variant.options[1]);
        state.coffee = variant.options[0] === 'Decaf' ? 'decaf' : coffee;
        state.frequency = /2 weeks/i.test(plan.name) ? 'fortnightly' : 'monthly';
        field('grind').value = properties.Grind;
        field('grind').dispatchEvent(new Event('change', { bubbles: true }));
        field('gift').checked = properties.Gift === 'Yes';
        field('recipient').value = properties.Recipient || '';
        field('message').value = properties['Gift message'] || '';
        one('[data-tempo-edit-copy]').textContent = `Your bag changes only when you save. ${editingItem.quantity > 1 ? `Quantity ${editingItem.quantity} will be kept; prices below are for one subscription.` : 'Your existing quantity will be kept.'}`;
      } catch (error) {
        editInvalid = true;
        one('[data-tempo-error]').textContent = error.message;
        one('[data-tempo-error]').hidden = false;
        one('[data-tempo-edit-copy]').textContent = 'Your bag has not been changed.';
      } finally {
        editLoading = false;
        draw();
      }
    }
    root.dataset.tempoLoaded = 'true';
  }
  const start = () => document.querySelectorAll('[data-tempo-builder], [data-tempo-promo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
